import { useState } from "react"
import DynamicCardRow from "../../../components/AdminPortalComponents/DynamicCardRow/DynamicCardRow"
import DynamicSquaredFilterBar from "../../../components/common/AdminCommonComponents/FilterBars/DynamicSquaredFilterBar/DynamicSquaredFilterBar"
import LightGrayBgWrapper from "../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import CommissionBySellerType from "../../../components/AdminPortalComponents/PricingFinanceAndPayments/FeeAndCommissionStructure/CommissionBySellerType/CommissionBySellerType"
import AddNewSellerType from "../../../components/AdminPortalComponents/PricingFinanceAndPayments/FeeAndCommissionStructure/CommissionBySellerType/AddNewSellerType/AddNewSellerType"
import CommissionByProductCategory from "../../../components/AdminPortalComponents/PricingFinanceAndPayments/FeeAndCommissionStructure/CommissionByProductCategory/CommissionByProductCategory"
import OtherPlatformFees from "../../../components/AdminPortalComponents/PricingFinanceAndPayments/FeeAndCommissionStructure/OtherPlatformFees/OtherPlatformFees"
import AddNewFeeForm from "../../../components/AdminPortalComponents/PricingFinanceAndPayments/FeeAndCommissionStructure/OtherPlatformFees/AddNewFeeForm/AddNewFeeForm"

const PricingFinanceAndPayment = () => {
  const cardsData = [
    { title: "Subscription Fee collected".toUpperCase(), value: 0 },
    { title: "Transaction fee Collected".toUpperCase(), value: 0 },
    { title: "Other Commissions".toUpperCase(), value: 0 },
  ]

  const tabs = [
    { key: "commissionBySellerType", label: "Commission by Seller Type" },
    { key: "commissionByProductCategory", label: "Commissions by Product Category" },
    { key: "otherPlatformFees", label: "Other Platform Fees" },
  ]

  const [activeTab, setActiveTab] = useState(tabs[0].key)
  const [addSellerTypeFormOpen, setAddSellerTypeFormOpen] = useState(false)
  const [showAddNewFeeForm, setShowAddNewFeeForm] = useState(false)


  const renderContent = {
    commissionBySellerType: addSellerTypeFormOpen ? (
      <AddNewSellerType setAddSellerTypeFormOpen={setAddSellerTypeFormOpen} />
    ) : (
      <CommissionBySellerType setAddSellerTypeFormOpen={setAddSellerTypeFormOpen} />
    ),

    commissionByProductCategory: <CommissionByProductCategory />,

    otherPlatformFees: showAddNewFeeForm ? <AddNewFeeForm onClick={setShowAddNewFeeForm} /> : <OtherPlatformFees onClick={setShowAddNewFeeForm} />
  }

  return (
    <LightGrayBgWrapper>
      <div className="shadow bg-white p-3">
        <div className="mb-3 fw-semibold fs-4">Overview</div>
        <DynamicCardRow cards={cardsData} />
      </div>

      <div className="my-3 shadow">
        <DynamicSquaredFilterBar tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} barType="white" />
      </div>

      {renderContent[activeTab] || null}
    </LightGrayBgWrapper>
  )
}

export default PricingFinanceAndPayment
